export const msalConfig = {
  auth: {
    clientId:
      process.env.REACT_APP_MICROSOFT_SSO_CLIENT_ID ||
      "15598883-6f61-49c2-b171-20b33de20daf",
    authority:
      process.env.REACT_APP_MICROSOFT_SSO_AUTHORITY ||
      "https://login.microsoftonline.com/e2e36961-c4a8-408f-b47f-de51ee72e337",
    redirectUrl:
      process.env.REACT_APP_MICROSOFT_SSO_REDIRECT_URL ||
      "https://purple-hill-0d19ad110.5.azurestaticapps.net",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};
